import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onBeforeMount, ref, watch } from 'vue';
import { useGettext } from '@jshmrtn/vue3-gettext';
import { useRoute, useRouter } from 'vue-router';
import { Flash } from '@/core/Flash';
import CmsPageForm from '@/modules/cms_page/components/CmsPageForm.vue';
import { CmsPage, useCmsPage } from '@/modules/cms_page/CmsPage';
import { handleLoadError } from '@/core/common';


export default /*@__PURE__*/_defineComponent({
  __name: 'CmsPageEdit',
  setup(__props) {

const { $gettext } = useGettext();
const route = useRoute();
const router = useRouter();
const cmsPage = ref<CmsPage | null>(null);

const load = async () => {
	try {
		const response = await useCmsPage().get(route.params.id as string);
		if (response) {
			cmsPage.value = response;
		}
	} catch (e) {
		handleLoadError(e as Error, 'cmsPage.index');
	}
};

watch(route, () => {
	if (route.params.id) {
		load();
	}
});
onBeforeMount(load);

const saved = (n) => {
	cmsPage.value = n;
	Flash.success($gettext('CMS-sida har sparats.'));
};

const cancel = () => {
	router.push({ name: 'cmsPage.index' });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CmsPageForm, {
    "page-title": _unref($gettext)('Redigera CMS-sida'),
    "cms-page": cmsPage.value,
    onSaved: saved,
    onCancel: cancel
  }, null, 8, ["page-title", "cms-page"]))
}
}

})